import { render, staticRenderFns } from "./iHandExtraFields.vue?vue&type=template&id=43db00a4"
import script from "./iHandExtraFields.vue?vue&type=script&lang=js"
export * from "./iHandExtraFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports